/**
 * Transition Tokens
 * Consistent timing and easing curves
 */

export const baseTransitions = {
  duration: {
    fastest: 100,
    fast: 150,
    normal: 200,
    slow: 300,
    slowest: 400
  },
  easing: {
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  }
} as const;
